/**
 * @author ydoni
 * @description 검정색 말풍선 info icon 정보 bubble tooltip
 */
import styled from "styled-components";
import { COLORS } from "styles/colors";
import { calcRem } from "styles/theme";

type InfoBubbleProps = {
  children: React.ReactNode;
  right?: boolean;
  left?: boolean;
  showAtTop?: boolean;
  atBottom?: boolean;
};

function InfoBubble({
  children,
  right,
  left,
  showAtTop,
  atBottom,
}: InfoBubbleProps): JSX.Element {
  return (
    <Container
      className="info-bubble"
      right={right}
      left={left}
      showAtTop={showAtTop}
      atBottom={atBottom}
    >
      {children}
    </Container>
  );
}

const Container = styled.div<{
  right?: boolean;
  left?: boolean;
  showAtTop?: boolean;
  atBottom?: boolean;
}>`
  position: relative;
  padding: 6px 10px;
  background: #000;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  color: ${COLORS.WHITE};
  white-space: nowrap;
  font-size: ${calcRem(12)};
  line-height: 17px;
  min-width: max-content;

  :after {
    content: "";
    position: absolute;
    border-style: solid;
    border-color: #000 transparent;
    display: block;
    width: 0;
    z-index: 1;
    ${({ atBottom }) =>
      atBottom
        ? `
        bottom: -15px;
        border-width: 23px 10px 0px;
      `
        : `
        top: -15px;
        border-width: 0 10px 23px;
    `}
    left: 50%;
    transform: translate(-50%, 0);
    ${({ left }) =>
      left &&
      `
      left: 6px;
      transform:unset;

    `}
    ${({ right }) =>
      right &&
      `
      left: unset;
        right: 6px;
      transform:unset;

      `}

    ${({ showAtTop }) =>
      showAtTop &&
      `
        display: none;
      `}
  }
`;

export default InfoBubble;

export const BubbleContainer = styled.div<{
  right?: boolean;
  atBottom?: boolean;
}>`
  position: absolute;
  ${({ atBottom }) => (atBottom ? `bottom: 35px;` : `top: 35px;`)}
  z-index: 666;

  ${({ right }) =>
    right
      ? `
    right: -50%;


  `
      : `
  left: 50%;
  transform: translateX(-50%);
  `}
`;
